import { render, staticRenderFns } from "./perforStatement.vue?vue&type=template&id=fb4ae6e6&scoped=true&"
import script from "./perforStatement.vue?vue&type=script&lang=js&"
export * from "./perforStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4ae6e6",
  null
  
)

export default component.exports